export default {
  note: {
    title: 'Notas especiales:',
    description: 'Intentaremos atender tus solicitudes, pero no podemos realizar cambios que afecten al precio.',
    placeholder: 'Añadir solicitud especial',
  },
  buttons: {
    add: '+ Añadir artículo',
    update_item: 'Actualizar',
    add_to_card: 'Añadir al carrito',
  },
  alcohol_warning: 'Este artículo tiene restricción de edad.',
  caffeine_warning:
    'Alto contenido en cafeína. No recomendado para niños ni mujeres embarazadas o en período de lactancia.{{value}}',
  error_messages: {
    product_unavailable: '¡Agotado!',
    item_not_added: 'No se pudo añadir el artículo. Por favor, inténtalo de nuevo.',
  },
  success_messages: {
    item_added: 'Artículo añadido correctamente',
  },
};
